module.exports = __webpack_public_path__ + "media/flags/im-b7ec5e98.svg";